module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"msg":{"focus":{"not_found":"対象の虫はこの画像内で検出されませんでした。"}}},"en":{"msg":{"focus":{"not_found":"Focused insect not found in this image."}}}}')
  delete Component.options._Ctor
}
